import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class WorldProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 5) {
      const choice = this.pick(ctx, [[0, 3, 0, 4], [0, 1, 0, 1], [0, 2, 3, 0]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    return [this.triad(ctx, 0), this.triad(ctx, 2)];
  }
}
